module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": "",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({}, on), [(_vm.task.due) ? _c('div', {
          directives: [{
            name: "ripple",
            rawName: "v-ripple"
          }],
          staticClass: "due-chip",
          style: ({
            'background-color': _vm.dueColour,
            opacity: _vm.dueOpacity
          })
        }, [(_vm.task.assigned) ? _c('ContactImage', {
          attrs: {
            "contact": _vm.task.assigned,
            "size": 28,
            "emptyTooltip": "Not Assigned"
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "due-content"
        }, [_vm._v("\n                    " + _vm._s(_vm.fromNow(_vm.task.due)) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.task.due) ? _c('div', {
          staticClass: "hoverable round pa-1",
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "grey lighten-1"
          }
        }, [_vm._v("event")])], 1) : _vm._e()])]
      }
    }]),
    model: {
      value: (_vm.calendarVisible),
      callback: function($$v) {
        _vm.calendarVisible = $$v
      },
      expression: "calendarVisible"
    }
  }, [_vm._v(" "), _c('div', {
    staticClass: "white-background columns-on-wide popup-content"
  }, [_c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "flat": ""
    },
    on: {
      "input": function($event) {
        _vm.calendarVisible = false
      }
    },
    model: {
      value: (_vm.backwardsDate),
      callback: function($$v) {
        _vm.backwardsDate = $$v
      },
      expression: "backwardsDate"
    }
  }), _vm._v(" "), (_vm.task.due) ? _c('div', {
    staticStyle: {
      "padding": "10px 10px 10px 10px",
      "border": "solid 1px #ddd",
      "width": "290px",
      "overflow-y": "auto"
    }
  }, [_vm._l((_vm.contacts), function(contact) {
    return _c('div', {
      key: contact._id,
      staticClass: "inline-block",
      staticStyle: {
        "margin": "3px"
      },
      on: {
        "click": function($event) {
          _vm.task.assigned = contact;
          _vm.calendarVisible = false
        }
      }
    }, [_c('ContactImage', {
      attrs: {
        "size": 48,
        "contact": contact
      }
    })], 1)
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "width": "105px",
      "margin-top": "5px"
    },
    attrs: {
      "color": "red",
      "text": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        return _vm.clearSchedule()
      }
    }
  }, [_vm._v("Clear")])], 2) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-790c7d35"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/flow/ui/DueIndicator.vue
// module id = 2615
// module chunks = 1